import type { Ref } from '@wix/materializer'
import { pointers, Component, SlotsDataItem } from '@wix/thunderbolt-becky-types'
import { createByRefsisTemplateCompNode } from '../../compNodeUtils'

type Dependencies = Ref<SlotsDataItem> | undefined
type ViewItem = Component | null

const {
	data: {
		DATA_MAPS: { SLOTS },
	},
} = pointers

const getComponents = (components: Array<string> | undefined, slotsDataItem: SlotsDataItem) => {
	if (!components) {
		return []
	}

	const slotsCompIds = new Set(Object.values(slotsDataItem.slots))
	return components.filter((compId) => !slotsCompIds.has(compId))
}

export const ComponentStructureWithSlots = createByRefsisTemplateCompNode<Dependencies, ViewItem>({
	getDependencies: (__, { slotsQuery }, scopedCreateRef) =>
		slotsQuery ? scopedCreateRef<SlotsDataItem>(SLOTS, slotsQuery) : undefined,
	toViewItem: (structure, slotsDataItem) => {
		if (!slotsDataItem) {
			return null // structure node was not created, see modelUpdate.ts#L300
		}

		if (slotsDataItem && slotsDataItem.slots) {
			return {
				...structure,
				components: getComponents(structure.components, slotsDataItem),
				slots: slotsDataItem.slots,
			}
		}

		return structure
	},
})
